var _path, _path2;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgEducationIcon = function SvgEducationIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65.09,
    height: 43.177,
    viewBox: "0 0 65.09 43.177",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M56.851,89.156a2.749,2.749,0,0,1-1.188-.271L34.77,78.86v9.014h.006c.153,5.777,9.673,10.437,21.4,10.437s21.244-4.66,21.4-10.437h.006V79.51L58.042,88.885A2.772,2.772,0,0,1,56.851,89.156Z",
    transform: "translate(-24.309 -55.134)",
    fill: "#1e4171"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M64.566,15.266,32.939.09a.919.919,0,0,0-.794,0L.521,15.266a.918.918,0,0,0,0,1.655L32.148,32.1a.919.919,0,0,0,.794,0L58.826,19.671v7.164A2.455,2.455,0,0,0,58.453,31l-.722,6.3h4.393L61.4,31a2.455,2.455,0,0,0-.373-4.161V18.621l3.541-1.7a.917.917,0,0,0,0-1.655Z",
    transform: "translate(0 0)",
    fill: "#1e4171"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgEducationIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/education-icon.9f41bd50.svg";
export { ForwardRef as ReactComponent };